import type { FavoriteFolderSummary, FavoriteSummary } from './api/types'

export function favoriteFolderPath(folders: FavoriteFolderSummary[], id: string): FavoriteFolderSummary[] {
  const path: FavoriteFolderSummary[] = [], seen = new Set<string>()
  let current = folders.find(folder => folder.id === id)
  while (current && !seen.has(current.id)) {
    path.unshift(current)
    seen.add(current.id)
    current = folders.find(folder => folder.id === current?.parent_id)
  }
  return path
}

export function findPageFavorite(favorites: FavoriteSummary[], revisionId: string, page: { page_ref: string; source_revision_id?: string; source_page_ref?: string }): FavoriteSummary | undefined {
  return favorites.find(item => item.revision_id === revisionId && item.page_ref === page.page_ref)
    ?? favorites.find(item => item.source_revision_id === (page.source_revision_id ?? revisionId) && item.source_page_ref === (page.source_page_ref ?? page.page_ref))
}
